import { render, staticRenderFns } from "./new_market.vue?vue&type=template&id=7b3040be&scoped=true&lang=pug"
import script from "./new_market.vue?vue&type=script&lang=js"
export * from "./new_market.vue?vue&type=script&lang=js"
import style0 from "./new_market.vue?vue&type=style&index=0&id=7b3040be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3040be",
  null
  
)

export default component.exports